import { CtaButton, Spinner } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledBodyText = styled.h1`
  font-size: ${rem('18px')};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.cross.deepBlu};
`;

export const StyledButton = styled(CtaButton)`
  cursor: pointer;
  display: flex;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledFlexWrapper = styled.div`
  display: flex;
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;
export const StyledCenteredSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
